import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Page3 = () => {
  const [openYears, setOpenYears] = useState(new Set());

  const timelineData = [
    { 
      year: "1976", 
      title: "Diretiva Seveso (Itália)", 
      description: "Acidente com nuvem tóxica de dioxina. O evento deu origem à Diretiva Seveso, estabelecendo a primeira legislação sobre a Política de Prevenção de Acidentes Graves (PPS) na Europa.", 
      side: "bottom" 
    },
    { 
      year: "1989", 
      title: "Explosão Phillips 66 (EUA)", 
      description: "Incêndio e explosões em Pasadena (Texas) causaram vítimas fatais. O desastre expôs criticamente os riscos de mudanças não gerenciadas em plantas industriais.", 
      side: "top" 
    },
    { 
      year: "1991", 
      title: "Instituição do OSHA PSM", 
      description: "Os EUA criam o padrão PSM (Process Safety Management), focado na prevenção de acidentes catastróficos em processos que manipulam substâncias altamente perigosas.", 
      side: "bottom" 
    },
    { 
      year: "1992", 
      title: "Obrigatoriedade do MOC", 
      description: "Com a entrada em vigor do OSHA PSM, em 26 de maio de 1992, o MOC tornou-se requisito legal obrigatório nos EUA para instalações com produtos químicos altamente perigosos.", 
      side: "top" 
    },
    { 
      year: "2018", 
      title: "MOC na ISO 45001", 
      description: "A publicação da norma ISO 45001:2018, em março de 2018, substitui a OHSAS 18001 e consolida o Gerenciamento de Mudança como prática global certificável em gestão de segurança.", 
      side: "bottom" 
    }
  ];

  const toggleYear = (year) => {
    setOpenYears(prev => {
      const newSet = new Set(prev);
      if (newSet.has(year)) {
        newSet.delete(year);
      } else {
        newSet.add(year);
      }
      return newSet;
    });
  };

  const isMobile = window.innerWidth < 768;

  return (
    <div>
      <Container style={{ paddingTop: '20px', paddingBottom: '20px' }}>
        
        {/* Cabeçalho */}
        <div className="text-center" style={{marginBottom: isMobile ? '80px' : '200px', marginTop: '80px'}}>
          <p className="fw-bold fs-4 mb-1" style={{fontSize: '18px'}}>Contexto Histórico</p>
          <p className="text-muted small px-3" style={{fontSize: '18px'}}>
            Entender esse percurso ajuda a compreender o cenário atual e a evolução da Segurança de Processo. Clique nas datas:
          </p>
        </div>

        {/* ================= DESKTOP ================= */}
        <div className="d-none d-md-block">

          <div className="position-relative d-flex align-items-center" 
              style={{ 
                maxWidth: '1200px', 
                margin: '0 auto',
                padding: '10px 15px'
              }}>
            
            <div 
              className="position-absolute start-0 end-0" 
              style={{
                top: '50%',
                height: '6px',
                background: 'linear-gradient(to right, #1e40af, #60a5fa, #1e40af)',
                zIndex: 1
              }}
            />

            <div className="d-flex justify-content-between w-100 position-relative flex-wrap flex-md-nowrap gap-3 gap-md-4">
              {timelineData.map((item) => {
                const isOpen = openYears.has(item.year);
                const isTop = item.side === "top";

                return (
                  <div key={item.year} className="text-center flex-fill" style={{ minWidth: '165px', position: 'relative' }}>
                    
                    {isTop && (
                      <div style={{ position: 'relative', zIndex: 2 }}>
                        <div onClick={() => toggleYear(item.year)} className="mx-auto mb-2 fw-bold"
                          style={{
                            backgroundColor: '#2563eb',
                            color: 'white',
                            padding: '9px 18px',
                            borderRadius: '9px',
                            fontSize: '1.35rem',
                            cursor: 'pointer'
                          }}>
                          {item.year}
                        </div>

                        <div
                          onClick={() => toggleYear(item.year)}
                          style={{
                            width: '26px',
                            height: '26px',
                            borderRadius: '50%',
                            backgroundColor: isOpen ? '#1e3a8a' : '#2563eb',
                            border: '4.5px solid white',
                            boxShadow: '0 0 0 4.5px #60a5fa',
                            zIndex: 2,
                            cursor: 'pointer',
                            margin: '0 auto',
                            display: 'block'
                          }}
                        />

                        <div style={{
                          position: 'absolute',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          bottom: '100%',
                          width: '290px',
                          opacity: isOpen ? 1 : 0
                        }}>
                          {isOpen && (
                            <div className="card border-0 shadow-sm">
                              <div className="card-body p-3">
                                <h6 className="fw-bold text-primary mb-2 small">{item.title}</h6>
                                <p className="small mb-0">{item.description}</p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {!isTop && (
                      <div style={{ position: 'relative', zIndex: 2, marginTop: '65px' }}>
                        <div
                          onClick={() => toggleYear(item.year)}
                          style={{
                            width: '26px',
                            height: '26px',
                            borderRadius: '50%',
                            backgroundColor: isOpen ? '#1e3a8a' : '#2563eb',
                            border: '4.5px solid white',
                            boxShadow: '0 0 0 4.5px #60a5fa',
                            zIndex: 2,
                            cursor: 'pointer',
                            margin: '0 auto',
                            display: 'block'
                          }}
                        />

                        <div onClick={() => toggleYear(item.year)} className="mx-auto mt-2 fw-bold"
                          style={{
                            backgroundColor: '#2563eb',
                            color: 'white',
                            padding: '9px 18px',
                            borderRadius: '9px',
                            fontSize: '1.35rem',
                            cursor: 'pointer'
                          }}>
                          {item.year}
                        </div>

                        <div style={{
                          position: 'absolute',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          top: '100%',
                          width: '290px',
                          opacity: isOpen ? 1 : 0
                        }}>
                          {isOpen && (
                            <div className="card border-0 shadow-sm">
                              <div className="card-body p-3">
                                <h6 className="fw-bold text-primary mb-2 small">{item.title}</h6>
                                <p className="small mb-0">{item.description}</p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* ================= MOBILE ================= */}
        <div className="d-md-none position-relative">

          <div style={{
            position: 'absolute',
            left: '20px',
            top: 0,
            bottom: 0,
            width: '4px',
            background: '#60a5fa'
          }} />

          {timelineData.map((item) => {
            const isOpen = openYears.has(item.year);

            return (
              <div key={item.year} className="d-flex mb-4 position-relative">

              <div
                onClick={() => toggleYear(item.year)}
                style={{
                  width: '26px',
                  height: '26px',
                  borderRadius: '50%',
                  backgroundColor: isOpen ? '#1e3a8a' : '#2563eb',
                  border: '4.5px solid white',
                  boxShadow: '0 0 0 4.5px #60a5fa',
                  marginRight: '15px',
                  zIndex: 2,
                  cursor: 'pointer',
                  flexShrink: 0
                }}
              />

                <div style={{ flex: 1 }}>
                  <div
                    onClick={() => toggleYear(item.year)}
                    style={{
                      backgroundColor: '#2563eb',
                      color: '#fff',
                      padding: '8px 14px',
                      borderRadius: '8px',
                      display: 'inline-block',
                      cursor: 'pointer',
                      marginBottom: '8px'
                    }}
                  >
                    {item.year}
                  </div>

                  {isOpen && (
                    <div className="card shadow-sm">
                      <div className="card-body">
                        <h6 className="fw-bold text-primary small">{item.title}</h6>
                        <p className="small mb-0">{item.description}</p>
                      </div>
                    </div>
                  )}
                </div>

              </div>
            );
          })}
        </div>

      </Container>
    </div>
  );
};

export default Page3;